import React, { useEffect, useRef, useState } from "react";
import "../../styles/questionnaire.css";
import "../../styles/chatTyper.css";
import { DUMMY_QUESTIONS } from "./dummyQuestionnaireData";
import WelcomeQuestion from "./QuestionTypes/WelcomeQuestion";
import TextQuestion from "./QuestionTypes/TextQuestion";
import NumberQuestion from "./QuestionTypes/NumberQuestion";
import DateQuestion from "./QuestionTypes/DateQuestion";
import RadioQuestion from "./QuestionTypes/RadioQuestion";
import CheckboxRadioQuestion from "./QuestionTypes/CheckboxRadioQuestion";
import ChatTyper from "./ChatTyper";
import { useTranslation } from "react-i18next";
import { PgStepper } from "../../components/PgStepper";
import { useNavigate } from "react-router-dom";

// Standalone demo of the classic (PG3) questionnaire.
// No API, no auth - answers drive a local conversation queue.
function DemoQuestionnaire() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const [conversationItems, setConversationItems] = useState([DUMMY_QUESTIONS[0]]);
  const [answerIndex, setAnswerIndex] = useState(0);
  const [showTyper, setShowTyper] = useState(false);
  const [done, setDone] = useState(false);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (conversationItems.length > 1) {
      const container = containerRef.current;
      container?.lastElementChild?.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, [conversationItems, done]);

  const addAnswer = (question, answer) => {
    question.answer = answer;
    const nextIndex = DUMMY_QUESTIONS.indexOf(question) + 1;
    setAnswerIndex(nextIndex);
    setShowTyper(true);
    setTimeout(() => {
      setShowTyper(false);
      if (nextIndex < DUMMY_QUESTIONS.length) {
        setConversationItems(DUMMY_QUESTIONS.slice(0, nextIndex + 1));
      } else {
        setDone(true);
      }
    }, 700);
  };

  const handleDone = () => {
    setFinished(true);
    setTimeout(() => navigate("/"), 1200);
  };

  return (
    <div className="container-fluid demo-questionnaire">
      <div className="container-xxll pt-1 pt-lg-5 px-lg-5 px-2">
        <div className="row mt-4 justify-content-center justify-content-lg-between">
          <div className="col-12 col-lg-6">
            <div className="pg-title">
              {t("questionnaire")}
              <span className="pg-text textc-primary ms-3 small">
                Demo - dummy data
              </span>
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div className="w-100 float-end pg-text textc-primary">
              {!finished && <PgStepper current={answerIndex > 1 ? 2 : 1} />}
            </div>
          </div>
        </div>
      </div>

      <div
        className="element container-xxl"
        id="containerElement"
        ref={containerRef}
        style={{ maxHeight: "75vh", overflow: "auto" }}
      >
        <div className="conversation-wrapper">
          {conversationItems.map((item, index) => (
            <div key={item.id} id={item.id + "Container"}>
              {item.question_type === "nan" && (
                <WelcomeQuestion
                  question={item}
                  addtextAnswer={(_idx, q, a) => addAnswer(q, a)}
                  index={index}
                  isEdit={false}
                  editAnswerText={""}
                  showSpinner={false}
                />
              )}
              {item.question_type === "date" && (
                <DateQuestion
                  question={item}
                  addtextAnswer={(_idx, q, a) => addAnswer(q, a)}
                  index={index}
                  isEdit={false}
                  editAnswerText={""}
                  showSpinner={false}
                />
              )}
              {item.question_type === "number" && (
                <NumberQuestion
                  question={item}
                  addtextAnswer={(_idx, q, a) => addAnswer(q, a)}
                  index={index}
                  isEdit={false}
                  editAnswerText={""}
                  showSpinner={false}
                />
              )}
              {item.question_type === "text" && (
                <TextQuestion
                  question={item}
                  addtextAnswer={(_idx, q, a) => addAnswer(q, a)}
                  index={index}
                  isEdit={false}
                  editAnswerText={""}
                  showSpinner={false}
                />
              )}
              {item.question_type === "radio" && (
                <RadioQuestion
                  question={item}
                  addtextAnswer={(_idx, q, a) => addAnswer(q, a)}
                  index={index}
                  isEdit={false}
                  editAnswerText={""}
                  showSpinner={false}
                />
              )}
              {item.question_type === "checkbox-radio" && (
                <CheckboxRadioQuestion
                  question={item}
                  addtextAnswer={(_idx, q, a) => addAnswer(q, a)}
                  index={index}
                  isEdit={false}
                  editAnswerText={""}
                  showSpinner={false}
                />
              )}
            </div>
          ))}
          {showTyper && <ChatTyper />}
          {done && !finished && (
            <div className="text-center my-4">
              <p className="pg-text">
                All questions answered. Thank you for completing the questionnaire.
              </p>
              <button className="btn bgc-primary text-light" onClick={handleDone}>
                Finish
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DemoQuestionnaire;
